import ArrangementSelectedItemAvatar from './ArrangementSelectedItemAvatar';

export default ArrangementSelectedItemAvatar;
